import moment, { Moment } from 'moment';

export const timezone = moment().utcOffset();

export const getTimeWithTimeZone = (time: string, format: string): string => {
  const timeWithCurrentTimeZone = moment(time, format)
    .add(timezone, 'minutes')
    .format('HH:mm');
  return timeWithCurrentTimeZone;
};

export const getUtcTime = (
  time: string,
  format: string,
  date?: Date
): string => {
  let timeWithoutTimezone;
  if (date) {
    timeWithoutTimezone = moment(
      `${moment(date).format('YYYY-MM-DD')} ${moment(time, format).format(
        'HH:mm'
      )}`,
      'YYYY-MM-DD HH:mm'
    )
      .subtract(timezone, 'minutes')
      .format('YYYY-MM-DD HH:mm');
  } else {
    timeWithoutTimezone = moment(time, format)
      .subtract(timezone, 'minutes')
      .format('HH:mm');
  }
  return timeWithoutTimezone;
};

export const getTimeDifference = (
  dayFrom: Moment,
  startTime: string,
  endTime: string,
  dayTo?: Moment
): number => {
  const diffInTime = moment(
    `${endTime} ${moment(dayTo || dayFrom).format('MMM, D')}`
  ).diff(`${startTime} ${moment(dayFrom).format('MMM, D')}`, 'minutes');
  return diffInTime;
};

type TimeStr = string | undefined;
export const formatTime = (time: TimeStr): number => {
  return +moment(time, 'HH:mm').format('x');
};

export const getFinishTime = (startTime: TimeStr, endTime: TimeStr): number => {
  if (!startTime || !endTime) {
    return 0;
  }
  const st = formatTime(startTime);
  const et = formatTime(endTime);
  const durationMS = et - st;
  return st + durationMS;
};
